import moment from 'moment'

export default (epoch) => {
  if (!epoch || epoch === 0) return 'N/A'

  return moment(epoch).format('M/D/YY, h:mm A')
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/formatters/summary_date_time.js
 **/